import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpRequest, HttpEventType } from '@angular/common/http';
import * as PricelistModels from '../../models/pricelist/pricelist';
import { EnvironmentService } from '../../../app/services/environment.service';
import { PricelistSearchModel } from '../../models/pricelist/pricelistSearch';
import * as Models from '../../models/commonModels';

@Injectable({
  providedIn: 'root'
})
export class PricelistService {

constructor(private httpClient: HttpClient,
            private environmentService: EnvironmentService) { }


  public set(Pricelist: Models.Request<PricelistModels.PricelistModel>) {

    const httpHeaders = new HttpHeaders()
    .set('Content-Type', 'application/json')
    .set('Cache-Control', 'no-cache');

    const options = {headers: httpHeaders};

    return this.httpClient.post<Models.Response<PricelistModels.PricelistModel>>(`${this.environmentService.getApiURL()}/pricelist/set`, Pricelist, options);
  }

  public getList(Search: PricelistSearchModel) {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    Search.RequestSignature = Math.random();

    const options = { headers: httpHeaders };

    return this.httpClient.post<PricelistModels.PricelistListModel>(`${this.environmentService.getApiURL()}/pricelist/list`, Search, options);

  }


  public get(Pricelist: Models.RequestModel) {

    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Cache-Control', 'no-cache');

    const options = { headers: httpHeaders };

    return this.httpClient.post<Models.Response<PricelistModels.PricelistModel>>(`${this.environmentService.getApiURL()}/pricelist/get`, Pricelist, options);
  }

}
